(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .config(route)
    .factory('swifPatrimoineContractTypeService', swifPatrimoineContractTypeService)
    .controller('PatrimoineConfigurationController', PatrimoineConfigurationController)
    .controller('PatrimoineControlTypesController', PatrimoineControlTypesController)
    .controller('PatrimoineContractTypesController', PatrimoineContractTypesController);


    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/patrimoine/configuration_view', {
            templateUrl: 'partials/patrimoine/configuration_view.html',
            controller: 'PatrimoineConfigurationController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineContractTypeService
        * @requires swif.framework.swifFrameworkService
    **/
    function swifPatrimoineContractTypeService(swif) {
        'ngInject';
        var service = {};
        service.swif = swif;
        service.getCollection = function () {
            return swif.collections.getCollection('contract_types');
        };
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                'contract_types',
                'patrimoine_contract_type',
                filter,
                {location: true}
            );
        };
        service.callback = function (error, data) {
            return service.getCollection().defaultActionCallback(error, data);
        };
        service.preValidate = function () {
            return true;
        };
        return service;
    }


    function PatrimoineConfigurationController($scope, $q, swif, userService, swifOpenbaseCustomFieldsService) {
        'ngInject';
        console.log('init PatrimoineConfigurationController');
        // #3069 temporary boolean for customFields 
        $scope.patrimonyCustomFields = swif.settings.app.features.patrimonyCustomFields;

        swifOpenbaseCustomFieldsService.createTemplateCollection().then(function (collection) {
            $scope.custom_fields_templates = collection;
        });
        $scope.customFieldsPreValidate = swifOpenbaseCustomFieldsService.sanitize;

        swif.settings.page.title = 'Patrimoine module configuration';
        $scope.modules = swif.module.modules;
        $scope.access_rights = userService.getAccessRights();
        $scope.loading = {items: {}};
        $scope.refresh = function () {
            swif.message.loading($scope.loading.items);
            var deferred = [];
            _.forEach([
                'contract_types',
                'control_types',
                'purchase_modes',
                'custom_fields_templates'
            ], function (name) {
                var collection = swif.collection.getCollection(name);
                if (collection) {
                    deferred.push(collection.getItems());
                }
            });
            $q.all(deferred).then(function () {
                swif.message.loading($scope.loading.items, 'ok');
            }, function () {
                swif.message.loading($scope.loading.items, 'ko');
            });
        };
    }


    function PatrimoineControlTypesController($scope, patrimoine) {
        'ngInject';
        console.log('init PatrimoineControlTypesController');
        var defaultVals = {has_recurrence: true};
        _.defaults($scope.model, defaultVals);
        $scope.callback = patrimoine.control_type.callback;
        $scope.preValidate = patrimoine.control_type.preValidate;

        $scope.filters = {};

        patrimoine.control_type.createCollection().then(function (collection) {
            $scope.control_types = collection;
        });
    }


    function PatrimoineContractTypesController($scope, patrimoine) {
        'ngInject';
        console.log('init PatrimoineContractTypesController');
        $scope.callback = patrimoine.contract_type.callback;
        $scope.preValidate = patrimoine.contract_type.preValidate;
        patrimoine.contract_type.createCollection().then(function (collection) {
            $scope.categories = collection;
        });
    }


})();
